// extracted by mini-css-extract-plugin
module.exports = {"heroBanner":"hero-banner-module__heroBanner___1g55B"};